import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=4d4fd2d7&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=4d4fd2d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fd2d7",
  null
  
)

export default component.exports